module.exports = __webpack_public_path__ + "images/close-white.b2ee0c68ffacb61c0f4df8fb7a15fbfc.svg";